// extracted by mini-css-extract-plugin
export default {"contact_text":"Contact_contact_text__CIQDx","contact_link":"Contact_contact_link__VPHd5","contact_me":"Contact_contact_me__3h3st"};